export function formatUserName(
  firstName?: string | null,
  lastName?: string | null,
) {
  const name = `${firstName || ""} ${lastName || ""}`.trim()
  return name || "Unknown User"
}

/** The person as the sentences about one user name them: first name, else e-mail, else id. */
export function formatUserFirstName(user: {
  Id: number
  FirstName?: string | null
  Email?: string | null
}) {
  return user.FirstName || user.Email || `User ${user.Id}`
}
